import { render, staticRenderFns } from "./ListSummaryWebpartTest.vue?vue&type=template&id=6bc12f96"
import script from "./ListSummaryWebpartTest.vue?vue&type=script&lang=js"
export * from "./ListSummaryWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports